import React from 'react';
import PropTypes from 'prop-types';

const FilterTrigger = ({ openModal }) => {
  return (
    <button
      type="button"
      className="main-checkbox-filter__props ml-5"
      data-testid="triggerModalFilterDataSet"
      onClick={openModal}
    >
      <i className="icon icon-filter font-10 in-blue-500" />
    </button>
  );
};

FilterTrigger.propTypes = {
  openModal: PropTypes.func.isRequired
};

export default FilterTrigger;
